<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col
          cols="12"
        >
        <h3 class="text-decoration-underline input-text-size">Transaction Configuration:</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="9"
          md="4"
        >
          <v-checkbox
            v-model="editItem.usedLastBusinessDate"
             class="input-text-size radio-and-checekbox-size"
            label="Enable Last Used Business Date"
          ></v-checkbox>
        </v-col>
        <v-col
          cols="9"
          md="4"
        >
          <v-checkbox
            v-model="editItem.disableAutofillMortgagee"
             class="input-text-size radio-and-checekbox-size"
            label="Disable Autofill Mortgagee from Received Of"
          ></v-checkbox>
        </v-col>
        <v-col
          cols="9"
          md="4"
        >
          <v-checkbox
            v-model="editItem.editWkst"
            class="input-text-size radio-and-checekbox-size"
            label="Enable edit of workstation number"
          ></v-checkbox>
        </v-col>
        <v-col cols="3" class="pt-0 pb-0 mt-n0">
          <v-row>
            <v-col cols="4">
              <label class="input-text-size font-weight-light">Default Wkst#:</label>
            </v-col>
            <v-text-field
              class="input-text-size pa-0"
              v-model="editItem.defaultWkstNo"
            />
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="9"
          md="4"
        >
          <v-checkbox
            v-model="editItem.disableUsernameOnSignatureLine"
            class="input-text-size radio-and-checekbox-size"
            label="Disable Username on Signature Line"
          ></v-checkbox>
        </v-col>
        <v-col
          cols="9"
          md="4"
        >
          <v-checkbox
            v-model="editItem.noAuditRecordOnVoids"
            class="input-text-size radio-and-checekbox-size"
            label="No audit record on voids"
          ></v-checkbox>
        </v-col>
        <v-col
          cols="9"
          md="4"
        >
          <v-checkbox
            v-model="editItem.isSeparateCashBankDepositEntries"
            class="input-text-size radio-and-checekbox-size"
            label="Separate Cash Bank Deposit Entries"
          ></v-checkbox>
        </v-col>
        <v-col
          cols="9"
          md="4"
        >
          <v-checkbox
            v-model="editItem.enableAutofillofPaidByfromReceivedOf"
            class="input-text-size radio-and-checekbox-size"
            label="Enable Autofill of Paid by from Received Of"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
         <CommonDropDownsMixin class="mt-n3 mr-1" :isItTaxFee=true @change="dataFromCommonDropDowns"
              :taxFeeNumValue="editItem.mtgTaxCertFeeNumber"
              taxFeeLabelOverride="Mtg Tax Cert Fee Number"
              taxFeeNameOverride="mtgTaxCertFeeNumber" />
      </v-row>
      <v-row>
        <v-col cols="12">
        <h3 class="text-decoration-underline input-text-size">Print Settings:</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" md="4">
          <v-text-field
            v-model.number="editItem.numberOfCopies"
            label="Number of Copies"
            type="number"
            id="mtgSettingNumOfCopiesTextField"
            class="mtg-setting-num-of-copies-text-field input-text-size"
            :rules="numberOfCopiesValidation"
          ></v-text-field>
        </v-col>
        <v-col cols="3" md="4">
          <v-checkbox
            v-model.number="editItem.PrintCashCheckOtherAmount"
            class="input-text-size radio-and-checekbox-size"
            label="Print Cash/Check/Other Amount"
          ></v-checkbox>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
        <h3 class="text-decoration-underline input-text-size">EFT Payment Types:</h3>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="3">
          <v-select
            v-model="editItem.eftPayementTypeSimplifile"
            class="input-text-size"
            label="Simplifile"
            :items="bank"
            item-text="bankAltKey"
            item-value="_id"
          ></v-select>
        </v-col>
        <v-col cols="3">
          <v-select
            v-model="editItem.eftPayementTypeOtc"
            class="input-text-size "
            label="OTC"
            :items="bank"
            item-text="bankAltKey"
            item-value="_id"
          ></v-select>
        </v-col>
        <v-col cols="3">
          <v-select
            v-model="editItem.eftPayementTypeIrs"
            class="input-text-size"
            label="IRS"
            :items="bank"
            item-text="bankAltKey"
            item-value="_id"
          ></v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="3">
          <v-select
            v-model="editItem.eftPayementTypeForte"
            class="input-text-size"
            label="Forte"
            :items="bank"
            item-text="bankAltKey"
            item-value="_id"
          ></v-select>
        </v-col>
        <v-col cols="3">
          <v-select
            v-model="editItem.eftPayementTypeCsc"
            class="input-text-size"
            label="CSC"
            :items="bank"
            item-text="bankAltKey"
            item-value="_id"
          ></v-select>
        </v-col>
        <v-col cols="3">
          <v-select
            v-model="editItem.eftPayementTypeServiceOklahoma"
            class="input-text-size"
            label="OST"
            :items="bank"
            item-text="bankAltKey"
            item-value="_id"
          ></v-select>
        </v-col>
        <v-col cols="3">
          <v-select
            v-model="editItem.eftPayementTypeOther"
            class="input-text-size"
            label="Other"
            :items="bank"
            item-text="bankAltKey"
            item-value="_id"
          ></v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
        <h3 class="text-decoration-underline input-text-size">General Payment Types:</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
        <v-select
         class="input-text-size"
          label="Cash/ Check Deposit Bank"
          :items="bank"
          item-text="bankAltKey"
          item-value="_id"
          v-model="editItem.cashAndCheckDepositBank"
        ></v-select>
      </v-col>
      <v-col cols="3">
        <v-select
          class="input-text-size"
          label="CC Deposit bank"
          :items="bank"
          item-text="bankAltKey"
          item-value="_id"
          v-model="editItem.creditCardDepositBank"
        ></v-select>
      </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
        <h3 class="text-decoration-underline input-text-size">Forte Configuration:</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="editItem.apiAccessId"
            class="input-text-size"
            label="Forte API Access ID"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="editItem.apiSecureId"
            class="input-text-size"
            label="Forte API Secure Key"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="editItem.forteLocationId"
            class="input-text-size"
            label="Forte Location ID"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
        <h3 class="text-decoration-underline input-text-size">Payrix Configuration:</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="editItem.payrixMerchantId"
            class="input-text-size"
            label="Payrix Merchant ID"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="editItem.payrixEntityId"
            class="input-text-size"
            label="Payrix Entity ID"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
        <h3 class="text-decoration-underline input-text-size">Import Configuration:</h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="9"
          md="4"
        >
          <v-checkbox
            v-model="editItem.activateCsc"
            class="input-text-size radio-and-checekbox-size"
            label="Activate CSC Integration"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          id="mtgSettingSaveBtn"
          class="mtg-setting-save-btn"
          depressed
          color="primary"
          @click="update"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { cloneItem } from '../../util/shared/vue-global';
import '../../assets/style.css';
import CommonDropDownsMixin from '../tax/common-utils/CommonDropDowns.mixin.vue';

const bankCrudKey = 'sharedBank';

export default {
  mixins: [CommonDropDownsMixin],
  components: {
    CommonDropDownsMixin,
  },
  data: () => ({
    originalMtgSetting: null,
  }),
  computed: {
    ...mapState({
      editItem: (state) => {
        const settings = { ...state.SystemConfig.mtgSettingItem || {} };
        settings.numberOfCopies = settings.numberOfCopies || 2;
        return settings;
      },
    }),
    ...mapGetters('base/crud', [
      'items',
    ]),
    numberOfCopiesValidation() {
      return [
        (value) => {
          if (value === '' || value === undefined) {
            return true;
          }
          if (parseFloat(value) < 1) {
            return 'Invalid number of copies!';
          }
          return true;
        },
      ];
    },
    bank() {
      const bankObjs = this.items(bankCrudKey) || [];
      const updatedBankObjs = bankObjs.map((b) => ({
        ...b,
        bankAltKey: ` ${b.altKeyBase || ''} - ${b.bankName}`,
      }));
      return [{ _id: null, bankAltKey: '', bankName: '' }, ...updatedBankObjs];
    },
  },
  async created() {
    await this.loadConfig({ requiredScope: 'mtgConfig' });
    this.originalMtgSetting = cloneItem(this.buildMtgConfigItem());
    this.loadBanks({
      criteria: {
        notEmptyAltKey: true,
        limit: 0,
      },
      baseCrudKey: bankCrudKey,
    });
    this.loadTaxFeeMasterTypes({
      criteria: { sortBy: [{ column: 'feeNumber', direction: 'asc' }] },
      postProcessTrans: this.postProccessTaxFeeData,
      baseCrudKey: 'sharedTaxFeeMaster',
    });
  },
  methods: {
    buildMtgConfigItem() {
      const settingItem = this.editItem;
      /* When you will update any new field in the Mtg setting,
        you need to add the field here. */
      return {
        id: settingItem.id,
        usedLastBusinessDate: settingItem.usedLastBusinessDate,
        disableAutofillMortgagee: settingItem.disableAutofillMortgagee,
        editWkst: settingItem.editWkst,
        defaultWkstNo: settingItem.defaultWkstNo,
        disableUsernameOnSignatureLine: settingItem.disableUsernameOnSignatureLine,
        noAuditRecordOnVoids: settingItem.noAuditRecordOnVoids,
        isSeparateCashBankDepositEntries: settingItem.isSeparateCashBankDepositEntries,
        enableAutofillofPaidByfromReceivedOf: settingItem.enableAutofillofPaidByfromReceivedOf,
        mtgTaxCertFeeNumber: settingItem.mtgTaxCertFeeNumber,
        numberOfCopies: settingItem.numberOfCopies,
        PrintCashCheckOtherAmount: settingItem.PrintCashCheckOtherAmount,
        eftPayementTypeSimplifile: settingItem.eftPayementTypeSimplifile,
        eftPayementTypeOtc: settingItem.eftPayementTypeOtc,
        eftPayementTypeIrs: settingItem.eftPayementTypeIrs,
        eftPayementTypeForte: settingItem.eftPayementTypeForte,
        eftPayementTypeCsc: settingItem.eftPayementTypeCsc,
        eftPayementTypeServiceOklahoma: settingItem.eftPayementTypeServiceOklahoma,
        eftPayementTypeOther: settingItem.eftPayementTypeOther,
        cashAndCheckDepositBank: settingItem.cashAndCheckDepositBank,
        creditCardDepositBank: settingItem.creditCardDepositBank,
        apiAccessId: settingItem.apiAccessId,
        apiSecureId: settingItem.apiSecureId,
        forteLocationId: settingItem.forteLocationId,
        payrixMerchantId: settingItem.payrixMerchantId,
        payrixEntityId: settingItem.payrixEntityId,
        activateCsc: settingItem.activateCsc,
      };
    },
    async update() {
      if (window.confirm('Are you sure want to update this configuration?')) {
        const payload = {
          calledScope: 'mtgConfig',
          item: this.buildMtgConfigItem(),
          previousItem: this.originalMtgSetting,
          isLogAudit: true,
        };
        const ok = await this.$store.dispatch('SystemConfig/updateConfig', payload);
        if (ok) {
          this.originalMtgSetting = cloneItem(this.buildMtgConfigItem());
        }
      }
    },
    ...mapActions('shared/bank', [
      'loadBanks',
    ]),
    ...mapActions('SystemConfig', [
      'loadConfig',
    ]),
    dataFromCommonDropDowns(val, whichField) {
      this.editItem[whichField] = val;
    },
  },
};
</script>
